import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting for instant answer expansion in the brand self-serve help center
 */
export const SELF_SERVE_BRAND_INSTANT_ANSWERS_241209 =
  'SELF_SERVE_BRAND_INSTANT_ANSWERS_241209' as SettingConst<
    'SELF_SERVE_BRAND_INSTANT_ANSWERS_241209',
    boolean,
    'HELP_CENTER'
  >;
